import * as React from 'react'
import { IDevice } from '../../../interfaces/types.ts'
import { ScheduleSleep } from '../ScheduleSleep/ScheduleSleep.tsx'

interface Props {
    tracker?: IDevice
    outline?: boolean
    disabled?: boolean
}

export const SleepModeButton: React.FC<Props> = (props) => {
    const { tracker, outline, disabled } = props
    const [open, setOpen] = React.useState(false)

    const isSleeping = tracker?.status.sleeping === true
    const isDisabled = disabled || isSleeping

    const style = `btn btn-xs btn-secondary without-ring h-[22px] text-[10px] border-1 border-white w-[7rem] btn-secondary flex items-center justify-center p-0 leading-[22px]`

    const button = outline ? (
        <button
            className={style}
            onClick={() => setOpen(true)}
            disabled={isDisabled}
        >
            Sleep
        </button>
    ) : (
        <div className={`flex flex-col items-center rounded-lg bg-secondary py-1 px-3 border-white border-2 ${isDisabled ? 'opacity-50' : ''}`}>
            <button className={`btn btn-xs btn-ghost text-white without-ring h-fit py-0`}
                    onClick={() => !isDisabled && setOpen(true)} disabled={isDisabled}>
                Sleep
            </button>
        </div>
    )

    return (
        <div className={`cursor-pointer`} onClick={() => setOpen(!open)}>
            {button}
            {tracker ? <ScheduleSleep tracker={tracker} open={open} setOpen={setOpen} disabled={isDisabled} /> : null}
        </div>
    )
}
